import { render, staticRenderFns } from "./subChainsTable.vue?vue&type=template&id=6fc592a2"
import script from "./subChainsTable.vue?vue&type=script&lang=js"
export * from "./subChainsTable.vue?vue&type=script&lang=js"
import style0 from "./subChainsTable.vue?vue&type=style&index=0&id=6fc592a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports